import { LoaderFunction } from 'react-router-dom';
import { Bakery2bTabs } from '../states/tabState.model';

export const bakery2bLoader: LoaderFunction = async ({ params }) => {
  const { tab } = params || {};
  if (!tab || !Object.values(Bakery2bTabs).includes(tab as Bakery2bTabs)) {
    location.href = '/404';
  }
  return {
    tab,
    // todo 2398: add types for bakery2b
    some: 'some',
  };
};
